import React from "react";
import styles from "./TermsCondition.module.css";
import RichText from "../RichText/RichText";
const TermsConditionDescription = ({ data }: any) => {
  return (
    <div className="container">
      <div className={styles.terms_condition_row}>
        <RichText data={data} />
      </div>
    </div>
  );
};

export default TermsConditionDescription;
